import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow-left.svg'
import _imports_1 from '@/assets/img/card-online.png'
import _imports_2 from '@/assets/img/clubcard-loyalty.png'
import _imports_3 from '@/assets/img/clubcard-gold.svg'
import _imports_4 from '@/assets/img/lotuss-coin.png'
import _imports_5 from '@/assets/img/star-green.png'
import _imports_6 from '@/assets/img/redeem.svg'
import _imports_7 from '@/assets/img/right.svg'
import _imports_8 from '@/assets/img/history.svg'


const _withScopeId = n => (_pushScopeId("data-v-10c712a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "QR ของฉัน", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "modal-barcode" }
const _hoisted_6 = {
  key: 0,
  class: "lite-phone"
}
const _hoisted_7 = { class: "lite-phone-number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lite-phone-tag" }, "สมาชิกขั้นต้น", -1))
const _hoisted_9 = { class: "clubcard-card-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-card-content-image lite",
  src: _imports_1,
  alt: "Clubcard"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "clubcard-card-content-image",
  src: _imports_2,
  alt: "Clubcard"
}
const _hoisted_13 = {
  key: 2,
  class: "clubcard-card-content-image",
  src: _imports_3,
  alt: "Clubcard"
}
const _hoisted_14 = { class: "clubcard-card-content-container" }
const _hoisted_15 = { class: "label-point" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-card-content-coin",
  src: _imports_4,
  alt: "Coin"
}, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "label-tiered-point"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("svg", { id: "barCode" }),
  /*#__PURE__*/_createElementVNode("canvas", { id: "qrCode" })
], -1))
const _hoisted_19 = {
  key: 0,
  class: "lite-upgrade-section"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"lite-upgrade-badge\" data-v-10c712a3><img class=\"lite-upgrade-badge-icon\" src=\"" + _imports_5 + "\" alt=\"\" data-v-10c712a3><span data-v-10c712a3>My Lotus’s</span></div><div class=\"lite-upgrade-content\" data-v-10c712a3><div class=\"lite-upgrade-title\" data-v-10c712a3>เริ่มต้นใช้งาน มายโลตัส</div><div class=\"lite-upgrade-subtitle\" data-v-10c712a3>ใช้คอยน์ แลกรีวอร์ด</div></div>", 2)
const _hoisted_22 = { class: "footer action-buttons" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_6,
  alt: "แลกรีวอร์ด"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "action-btn-container" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "action-btn-text" }, "แลกรีวอร์ด"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "arrow",
    src: _imports_7
  })
], -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_8,
  alt: "ประวัติ"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "action-btn-container" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "action-btn-text" }, "ประวัติคอยน์"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "arrow",
    src: _imports_7
  })
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-barcode-section",  [ _ctx.customerTier === 'GOLD' ? 'gold-bg' : 'loyalty-bg' ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-content", { lite: _ctx.isLite }])
        }, [
          (_ctx.isLite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.phoneNumber), 1),
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isLite)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "clubcard-card-content-image-wrapper",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.upgradeToLoyalty()))
                }, _hoisted_11))
              : (_ctx.customerTier !== 'GOLD')
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (_ctx.customerTier === 'GOLD')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.getLabelPoints()), 1)
              ]),
              (_ctx.points !== 0 && _ctx.tieredPoints?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.getLabelTieredPoints()), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_18
        ], 2),
        (_ctx.isLite)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", {
                class: "lite-upgrade-btn",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.upgradeToLoyalty()))
              }, "ยืนยันตัวตน")
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", {
        class: "action-btn",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.openModalCouponBZB()))
      }, _hoisted_25),
      _createElementVNode("div", {
        class: "action-btn",
        onClick: _cache[4] || (_cache[4] = $event => (_ctx.openCoinHistory()))
      }, _hoisted_28)
    ])
  ]))
}